export default {
  name: {
    id: 'rm_metal_ruthenium_name',
    defaultMessage: 'Ruthenium',
  },
  smartphoneLabel: {
    id: 'rm_metal_ruthenium_smartphone_label',
    defaultMessage: 'Trace (invisible to the naked eye)',
  },
  whatItDoesText: {
    id: 'rm_metal_ruthenium_what_it_does',
    defaultMessage:
      'Ruthenium is a hard, silvery precious metal that refuses to melt, refuses to rust and refuses to corrode, which is exactly what you want in a component that has to survive years of heat inside a sealed phone. It sits in the microscopic resistors and memory layers that keep your device counting, storing and remembering.',
  },
  extractionText1: {
    id: 'rm_metal_ruthenium_extraction_p1',
    defaultMessage:
      'Ruthenium is one of six platinum group metals (PGMs), alongside palladium, iridium, osmium, rhodium and platinum. It is recovered as a co-product or by-product of other metals, often from nickel and copper ores. Most is mined in South Africa. The ore is concentrated and smelted into a nickel, copper and platinum metal mixture. Chemical refining then removes the base metals and separates the precious metals, including ruthenium.',
  },
  quickFactText: {
    id: 'rm_metal_ruthenium_quick_fact',
    defaultMessage:
      'Ruthenium is almost invisible inside your phone, but cannot easily be produced on demand. Nearly 90% comes from one country, recovered only alongside other metals.',
  },
  envSummaryText: {
    id: 'rm_metal_ruthenium_env_summary',
    defaultMessage:
      'Ruthenium comes from the same large-scale mining and processing operations as other platinum-group metals. The ore contains only small amounts of metal, so producing it requires large quantities of rock, water and energy. Mining waste can also contaminate soil and water.',
  },
  envWaterText: {
    id: 'rm_metal_ruthenium_env_water_text',
    defaultMessage:
      'Extraction of platinum family metals carries a documented risk of acid mine drainage: when sulphur bearing rock is broken open and meets air and water, it produces acidic run off that can carry heavy metals into rivers and groundwater. The lower the grade of the ore, the more water is needed per kilogram of metal recovered, and pollutants deposited by metal mining stay in river systems for a long time.',
  },
  envSoilText: {
    id: 'rm_metal_ruthenium_env_soil_text',
    defaultMessage:
      'Ruthenium is recovered from platinum-group ores, so its soil impacts are linked to the wider mining footprint. Removing topsoil, blasting rock and dumping waste drive erosion, while sulphide ores can generate acid drainage that releases arsenic, cadmium, mercury and selenium. Nearly 1 million km² of land is covered by mining-related waste worldwide. Because platinum-group ores contain only a few grams of metal per tonne, lower-grade deposits create even more waste per kilogram recovered.',
  },
  envBiodiversityText: {
    id: 'rm_metal_ruthenium_env_biodiversity_text',
    defaultMessage:
      'In South Africa, platinum-group operations use around 8 to 24 square metres of land per kilogram of metal. Mine shafts, processing plants and waste-storage sites transform landscapes, while dust, noise, water pollution and mine expansion can put pressure on nearby habitats.',
  },
  envClimateText: {
    id: 'rm_metal_ruthenium_env_climate_text',
    defaultMessage:
      'Producing 1 kg of platinum-group metals can emit around 25 to 80 tonnes of CO₂ equivalent. The impact is linked to the low concentration of the ore, the energy needed for crushing, concentration, smelting and refining, and the use of coal-powered electricity in South Africa the main producing region.',
  },
  humanSummaryText: {
    id: 'rm_metal_ruthenium_human_summary',
    defaultMessage:
      'Ruthenium is produced in large industrial operations rather than small informal mines. The wider platinum-group metals sector, of which ruthenium is a part, is a major source of employment, but it also has a history of fatal accidents, exposure to dust, wage disputes and conflicts between companies, workers and communities.',
  },
  humanHealthText: {
    id: 'rm_metal_ruthenium_human_health_text',
    defaultMessage:
      'Underground dust in platinum-group mines has caused cases of silicosis, a permanent lung disease. Mining deaths in South Africa have fallen significantly since the late 1980s, but fatal accidents still occur. In 2020, 16 of the country’s 60 mining deaths occurred in platinum-group mines.',
  },
  humanLegalText: {
    id: 'rm_metal_ruthenium_human_legal_text',
    defaultMessage:
      'In 2012, police killed 34 striking miners at the Marikana platinum-group metals mine in South Africa. Human rights organisations later criticised companies buying from the mine for failing to take responsibility for abuses in their supply chain.',
  },
  geoSummaryText: {
    id: 'rm_metal_ruthenium_geo_summary',
    defaultMessage:
      'Ruthenium is an exception to China’s broader dominance across many metals used in digital technologies. For ruthenium, the near-monopoly belongs to South Africa, which alone accounts for nearly 90% of global ruthenium mining. The European Union recognises ruthenium as both a critical and a strategic raw material.',
  },
  geoDugText: {
    id: 'rm_metal_ruthenium_geo_dug_text',
    defaultMessage:
      'Ruthenium is mainly recovered from platinum-group deposits in South Africa.',
  },
  geoProcessedText: {
    id: 'rm_metal_ruthenium_geo_processed_text',
    defaultMessage:
      'Ruthenium is generally refined alongside other platinum-group metals in the countries where they are mined. Some European refineries also process imported concentrates, industrial waste and end-of-life products.',
  },
  geoLeverageText: {
    id: 'rm_metal_ruthenium_geo_leverage_text',
    defaultMessage: 'Some export controls exist, but they are limited.',
  },
  supplySummaryText: {
    id: 'rm_metal_ruthenium_supply_summary',
    defaultMessage:
      'Ruthenium demand is small, yet its production depends on platinum and palladium mining. A disruption to the production of these metals could therefore reduce ruthenium supply, even if demand for ruthenium itself remains stable. Growing demand from electronics, nylon production, chemical catalysts and electrochemical applications could add further pressure. Persistently low prices for platinum, palladium and rhodium could also directly reduce ruthenium supply.',
  },
  supplyReservesText: {
    id: 'rm_metal_ruthenium_supply_reserves_text',
    defaultMessage:
      'Published reserve estimates cover all six platinum-group metals, not ruthenium alone. They put known reserves for the group at around 70,000 tonnes, with most global resources concentrated in South Africa and Russia. These figures do not indicate an immediate geological shortage at current overall production rates.',
  },
  supplyDemandText: {
    id: 'rm_metal_ruthenium_supply_demand_text',
    defaultMessage:
      'Global ruthenium demand was around 32 tonnes in 2021. Electronics accounted for 39% of demand, chemical catalysts for 37% and electrochemical applications for 14%. Demand could grow with hard-disk technologies, nylon production, ammonia catalysts and chlorine production.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_ruthenium_recycling_summary',
    defaultMessage:
      'Ruthenium can be recovered from industrial waste, electronic components and chemical catalysts. Its metallurgical recovery rates are lower than those achieved for platinum and palladium, but recycling remains technically possible.',
  },
  recyclingInputText: {
    id: 'rm_metal_ruthenium_recycling_input_text',
    defaultMessage:
      'Reliable global data are not available for ruthenium alone. Across the platinum-group metals as a whole, the European end-of-life recycling input rate is between 11% and 14%, meaning that this share of material entering Europe’s production system comes from end-of-life products.',
  },
  recyclingOutlookText: {
    id: 'rm_metal_ruthenium_recycling_outlook_text',
    defaultMessage:
      'Partly, but not completely. Ruthenium can be recovered from electronic and industrial waste, although recovery yields are lower than for platinum and palladium. Recycling can reduce the need for new mining, but it cannot fully replace primary supply because collection, sorting and refining are still required.',
  },
  footnote1Text1: {
    id: 'rm_metal_ruthenium_footnote_1_p1',
    defaultMessage:
      'Ruthenium figures are not reported in the usual USGS 2025 source for production data. They instead come from ADEME’s 2024 study. Global ruthenium production totalled 30.05 tonnes in 2022, roughly the weight of two city buses for the entire world in a single year.',
  },
} as const
